import type { ThunkAction } from "redux-thunk";
import type { RootState } from "~/app/store";
import type { AnyAction } from "~/app/store/types";
import { apiUpdateColumnSettings } from "~/features/search/components/ProductResults/views/NewTabularView/ConfigureColumnsButton/apiUpdateColumnSettings";
import { updateColumnVisibilityAction } from "~/features/search/redux/actions";

export function updateColumnVisibilityThunk(
  columnVisibility: { code: string; visible: boolean }[],
  isReset = false,
): ThunkAction<void, RootState, undefined, AnyAction> {
  return (dispatch, getState) => {
    const state = getState();
    const unitMode = state.userPreferences.unitMode;
    dispatch(updateColumnVisibilityAction(columnVisibility, unitMode));
    apiUpdateColumnSettings(columnVisibility, isReset);
  };
}
